var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('intalio-forms-render',{ref:'RandomRef_' + _vm.dynamicFormRandomRef,attrs:{"settings":"","id":_vm.formId,"documentdata":_vm.documentData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }